'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ajax = void 0;
const $ = require("jquery");
class Ajax {
    constructor() {
    }
    // 今日の一問：回答保存
    saveAnswer(postId, isCorrect, nonce, isExam = false) {
        const ajaxUrl = window.quizData?.ajaxUrl
            || window.examData?.ajaxUrl
            || '/wp-admin/admin-ajax.php';
        return $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'quiz_save_answer',
                post_id: postId,
                is_correct: isCorrect ? '1' : '0',
                nonce: nonce,
                is_exam: isExam ? '1' : '0',
            },
        });
    }
}
exports.Ajax = Ajax;
exports.default = Ajax;
